import type { FaireProductEntity } from "../../entity_types/product";

export const p_kqc75sqx2p: FaireProductEntity = {
  token: "p_kqc75sqx2p",
  type: "product",
  name: "Smooth Vodka Sauce (16oz)",
  brandToken: "b_jtn4n27qaj",
  brandName: "Noodo",
  imageUrl:
    "https://cdn.faire.com/fastly/3958e7835c4a66703276c3f3ca9064c707e6699dec4244e5e87db816448a4fbd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c25f5c55e5098b75ed47100adc759b5b0d7259838dbbef3a62786831a7aa0f2.jpeg",
    "https://cdn.faire.com/fastly/f25de0d025daa51843d9bf36f86eaa9d8db5afbff84586e4533436897f86cb38.jpeg",
  ],
  priceDollars: 5.99,
  description:
    "A luxurious, creamy vodka sauce crafted with nutrient-rich grass-fed bone broth and grass-fed heavy cream. Perfectly portioned for one, it’s ideal for quick solo meals in the city, delivering rich, indulgent flavor without compromising on wholesome ingredients.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:09.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
